/**
 * Name: ProgressBar
 * Author: @Gaurav
 * Date: 09-21-2020
 */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

export default function ProgressBar({ value }) {
  const classes = useStyles();
  const hasValue = typeof value === 'number' && Number.isFinite(value);
  const normalizedValue = hasValue ? Math.min(100, Math.max(0, value)) : undefined;

  return (
    <div className={classes.root}>
      <LinearProgress className="progressbar" {...(hasValue ? { variant: 'determinate', value: normalizedValue } : {})} />
    </div>
  );
}
